import React, { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import EnterpriseForm from '../../components/EnterpriseForm';
import { Enterprise } from 'models/Enterprises';
import api from 'api';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';

import './AddEnterprise.styles.scss';

type AddEnterpriseProps = {
  className?: string;
};

const AddEnterprise: React.FC<AddEnterpriseProps> = (props) => {
  const { className } = props;

  const [enterprise, setEnterprise] = useState<Enterprise>();

  const { popServerError } = useContext(PopNotificationsContext);

  const classes = classNames('add-enterprise', className);

  const { t } = useTranslation();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.enterprises.createInitial();
        setEnterprise(data);
      } catch (e) {
        popServerError(e);
      }
    })();
  }, [popServerError]);

  return (
    <div className={classes}>
      <div className="add-enterprise__heading">
        <h1>{t('addAnEnterprise')}</h1>
        <p>{t('addAnEnterpriseDescription')}</p>
      </div>

      <EnterpriseForm enterprise={enterprise} />
    </div>
  );
};

export default AddEnterprise;
